<template>
  <div class="content">
    <AboutUs v-if="show === 'AboutUs'" :content="content" :links="data.links" />
    <Brands v-if="show === 'Brands'" :content="content" :links="data.links" :brandName="brandName" />
    <Contact v-if="show === 'Contact'" :content="content" :links="data.links" />
    <IndustriesChild
      v-if="show === 'IndustriesChild'"
      :content="content"
      :icons="data.icons"
      :links="data.links"
    />
    <IndustriesParent
      v-if="show === 'IndustriesParent'"
      :content="content"
      :icons="data.icons"
      :links="data.links"
    />
    <Legal v-if="show === 'Legal'" :content="content" :links="data.links" />
    <ServicesChild
      v-if="show === 'ServicesChild'"
      :content="content"
      :icons="data.icons"
      :links="data.links"
    />
    <ServicesParent v-if="show === 'ServicesParent'" :content="content" :links="data.links" />
  </div>
</template>

<script>
import AboutUs from '@/components/content/AboutUs.vue'
import Brands from '@/components/content/Brands.vue'
import Contact from '@/components/content/Contact.vue'
import IndustriesChild from '@/components/content/IndustriesChild.vue'
import IndustriesParent from '@/components/content/IndustriesParent.vue'
import Legal from '@/components/content/Legal.vue'
import ServicesChild from '@/components/content/ServicesChild.vue'
import ServicesParent from '@/components/content/ServicesParent.vue'
import DE from '../assets/strings/DE.json'
import EN from '../assets/strings/EN.json'
import ES from '../assets/strings/ES.json'
export default {
  name: 'loval-content',
  components: {
    AboutUs,
    Brands,
    Contact,
    IndustriesChild,
    IndustriesParent,
    Legal,
    ServicesChild,
    ServicesParent
  },
  data () {
    return {
      data: '',
      show: '',
      type: '',
      content: '',
      brandName: ''
    }
  },
  created () {
    this.checkLang(this.$route)
    this.$route.params.content === 'default'
      ? this.$router.push({
        path: '/' + this.$route.params.lang + '/nav/services'
      })
      : null
    this.showContent(this.$route)
  },
  beforeRouteUpdate (to, from, next) {
    if (from.params.lang !== to.params.lang) {
      this.checkLang(to)
    }
    this.showContent(to)
    next()
  },
  methods: {
    checkLang (route) {
      switch (route.params.lang) {
        case 'ES':
          this.data = ES
          break
        case 'DE':
          this.data = DE
          break
        default:
          this.data = EN
          this.$route.params.lang = 'EN'
      }
    },
    showContent (to) {
      switch (to.params.type) {
        case 'industries':
          if (
            to.query.ps !== 'automation' &&
            to.query.ps !== 'electric' &&
            to.query.ps !== 'industrial'
          ) {
            to.query.ps = undefined
          }
          this.show =
            to.query.ps === undefined ? 'IndustriesParent' : 'IndustriesChild'
          this.content = this.data.industries.find(obj => {
            return obj.name === to.params.content
          })
          break
        case 'nav':
          switch (to.params.content) {
            case 'aboutus':
              this.show = 'AboutUs'
              this.content = this.data.nav.find(obj => {
                return obj.name === 'aboutus'
              })
              break
            case 'brands':
              this.show = 'Brands'
              this.content = this.data.nav.find(obj => {
                return obj.name === 'brands'
              })
              this.brandName = to.query.n
              break
            case 'contact':
              this.show = 'Contact'
              this.content = this.data.links.find(obj => {
                return obj.name === 'contact'
              })
              break
            case 'legal':
              this.show = 'Legal'
              this.content = this.data.links.find(obj => {
                return obj.name === 'legal'
              })
              break
            case 'services':
              if (to.query.ps === undefined) {
                this.show = 'ServicesParent'
                this.content = this.data.services
              } else {
                this.show = 'ServicesChild'
                this.content = this.data.services.types.find(obj => {
                  return obj.name === to.query.ps
                })
              }
              break
            default:
              this.$router.push({
                path: '/' + this.$route.params.lang + '/nav/services'
              })
          }
          break
        default:
          this.$router.push({
            path: '/' + this.$route.params.lang + '/nav/services'
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  width: calc(100% - (var(--nav-width) + var(--nav-arrow-width)));
  height: calc(100vh - var(--header-height) - var(--footer-height));
  flex-grow: 0;
  flex-shrink: 0;
  min-height: calc((2.5 * 80px) + var(--nav-title-height));
}
@media only screen and (min-width: 992px) {
  .content {
    min-height: calc((3.5 * 80px) + var(--nav-title-height));
  }
}
@media only screen and (min-width: 1200px) {
  .content {
    min-height: calc((5 * 80px) + var(--nav-title-height));
  }
}
</style>
